import { omit } from 'lodash';

import instanceEvents from './utils/instanceEvents';

export default function withProps(props) {
  return Component => ({
    name: `${Component.name}-with-props`,
    props: {
      ...omit(Component.props, ['typeDef', ...Object.keys(props)]),
    },
    render(createElement) {
      return createElement(
        Component,
        {
          props: {
            ...this.$props,
            ...props,
          },
          on: {
            ...instanceEvents(this),
          },
        },
        this.$slots.default,
      );
    },
  });
}
